// Nimmt ein date-Objekt entgegen und gibt einen String der Form 00.00.0000 zurück
export function formatDateToString(date) {
  var d = date.getDate();
  var m = date.getMonth() + 1; //Month from 0 to 11
  var y = date.getFullYear();
  return (d <= 9 ? '0' + d : d) + '.' + (m<=9 ? '0' + m : m) + '.' + y;
}

// addiert Tage zu einem Datum
export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

// subtrahiert Tage von einem Datum
export function subsDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
}